import {
    CHANGE_BIKE_MODEL_REQUEST, CHANGE_BIKE_MODEL_REQUEST_SUCCESS, CHANGE_BIKE_MODEL_REQUEST_FAILURE,
    CHANGE_BIKE_MODEL_LIST_REQUEST, CHANGE_BIKE_MODEL_LIST_REQUEST_SUCCESS, CHANGE_BIKE_MODEL_LIST_REQUEST_FAILURE,
} from '../../../BikeManagement/redux/constants/bike_model.constants';

const prefix = 'CHANGE'; const
    item = 'MODEL';
export const changeBikeModelRequest = (model_id, key, value, condition) => ({
    type: CHANGE_BIKE_MODEL_REQUEST, model_id, key, value, prefix, item, condition,
});

export const changeBikeModelRequestSuccess = (key, payload) => ({
    type: CHANGE_BIKE_MODEL_REQUEST_SUCCESS, key, payload,
});

export const changeBikeModelRequestFailure = error => ({
    type: CHANGE_BIKE_MODEL_REQUEST_FAILURE, error, prefix, item,
});

export const changeBikeModelListRequest = (model_id, key, value, condition) => ({
    type: CHANGE_BIKE_MODEL_LIST_REQUEST, model_id, key, value, condition,
});

export const changeBikeModelListRequestSuccess = (key, payload) => ({ type: CHANGE_BIKE_MODEL_LIST_REQUEST_SUCCESS, key, payload });
export const changeBikeModelListRequestFailure = error => ({ type: CHANGE_BIKE_MODEL_LIST_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/actions/change_bike_model.actions.js